var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_550)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_550",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_550",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAJ1BMVEUAAACAgID//////wDAwMAAAACAgAAAAICAAAAA//8AAP//AAD/AP+lPoo7AAAAAXRSTlMAQObYZgAAAMBJREFUKM+NkT0OgjAUgMvg7muqO6gHIGnCXGujxgVCe4R6AUPcnRw4Abt34Hg+AvbHgfANTfry9f2VkAUAsg7uSYakQYDyAa8kOzkgXICdRmAEX2QR5ZTCYQmVEwA1ntYbVOjYYMIZOcsxP/MGTYdS2hv0uMdGDspVYQK7A2rkz4BNxcBUxhmqVtpI5Q1Ea56rsFNdS6FmjedDXt6BUVw//HULZjl3jWz7YNqia3jbzxnhxrb3CEtWJqJc8td/fAFu8F6JJ+wqTwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.704076af474d0d3dda4a5577bd2bd126.svg";
export { ForwardRef as ReactComponent };